


export enum NatureType {
  Air = 1,
  Emulsion= 2,
  ANFO= 3,
  Emulsion_ANFOsup60= 4,
  Emulsion_ANFOinf50= 5,
  Dynamite= 6,
  Gel= 7,
  Booster= 8,
  Other= 9,
}

/**
 * Émulsions en vrac dont la teneur en émulsion dépasse 60 %. Leur densité varie à la mise en
 * œuvre : elles acceptent une plage acceptable en plus de la valeur nominale.
 */
export function supportsDensityRange(natureType: NatureType | null | undefined): boolean {
  return natureType === NatureType.Emulsion || natureType === NatureType.Emulsion_ANFOsup60;
}
